<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>User Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-tabs
      background-color="transparent"
      slider-size="1"
      v-model="tab"
      color="primary"
      :style="{
        paddingLeft: generalSpacingLeftRight + '%',
        paddingRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-tab class="tab-style" key="customers" href="#customers"
        >Customers</v-tab
      >
      <v-tab class="tab-style" key="operators" href="#operators"
        >Operators</v-tab
      >
      <v-tab class="tab-style" key="company" href="#company" v-if="isEditor"
        >Company</v-tab
      >
    </v-tabs>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-tabs-items
      style="background-color: transparent !important"
      v-model="tab"
    >
      <v-tab-item
        value="customers"
        key="customers"
        transition="false"
        reverse-transition="false"
      >
        <CustomerListing></CustomerListing>
      </v-tab-item>
      <v-tab-item
        value="operators"
        key="operators"
        transition="false"
        reverse-transition="false"
      >
        <OperatorListing></OperatorListing>
      </v-tab-item>
      <v-tab-item
        value="company"
        key="company"
        transition="false"
        reverse-transition="false"
      >
        <CompanyListing></CompanyListing>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import CustomerListing from "../components/CustomerListing.vue";
import OperatorListing from "../components/OperatorListing.vue";
import CompanyListing from "../components/CompanyListing.vue";

export default {
  components: {
    CustomerListing,
    OperatorListing,
    CompanyListing,
  },
  data: function () {
    return {
      tab: this.$route.params.tab,
      current_user_permission: [],
      current_user_company_doc_id: "",
      isEditor: false,
    };
  },
  created() {
    this.current_user_permission = this.$store.getters.getUserRoleList;
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      if (
        !this.current_user_permission.includes("Wbl2TAMLlfwkX8QDwztB") &&
        !this.current_user_permission.includes("Q5C0tm2ysYOI4lGPRODc") &&
        !this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.$router.push({ name: "HomeScreen" }).catch((err) => {});
      } else if (
        this.current_user_permission.includes("Wbl2TAMLlfwkX8QDwztB") ||
        this.current_user_permission.includes("UsVr0wHOjW29JiLaIv0E")
      ) {
        this.isEditor = true;
      }
    } else {
      this.isEditor = true;
    }
    // Update store
    var payload = { headerType: "needHeader", currentPage: "UserScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
  watch: {
    tab(new_value) {
      this.$router
        .push({ name: "UserScreen", params: { tab: new_value } })
        .catch((err) => {});
    },
  },
};
</script>

<style>
.tab-style {
  font-weight: bold !important;
  text-transform: capitalize !important;
  letter-spacing: 0px !important;
}
</style>